export enum AsyncProcessManagerAction {
  Initialized,
  ProcessStarted,
  ProcessFinished
}
